module.exports = __webpack_public_path__ + "img/news-image-review4.bf998ae0.png";